module.exports = __webpack_public_path__ + "static/03-1d95b70691a09584ec074e8b8e88af3e.jpg";